import { Text } from '@mantine/core';
import { CommonHash } from '@types';
import { REFERENCEDOCUMENTSOPTIONS, NOTEREASONS } from '@constants';
import styles from './DrawerPrevisualization.module.scss';
import dayjs from 'dayjs';

function References({ document }: { document: CommonHash }) {
  const referenceName = (value: string) => {
    const reference = REFERENCEDOCUMENTSOPTIONS.find((reference) => reference.value === value);
    return reference ? reference.label.split('-')[1] : '';
  };
  const referenceString = () => {
    const references: string[] = [];
    document.references_attributes.forEach((reference: any) => {
      const date = reference.date instanceof Date ? dayjs(reference.date).format('YYYY-MM-DD') : '';
      const reason = NOTEREASONS.find((reason) => reason.value === reference.code)?.label;
      if (reference.global_index) {
        references.push(
          `${reason || ''} ${referenceName(reference.original_dte_type).toUpperCase()} ${
            reference.description
          }`,
        );
      } else {
        references.push(
          `${reason || ''} ${referenceName(reference.original_dte_type).toUpperCase()} FOLIO ${
            reference.original_number
          } DEL ${date}`,
        );
      }
    });
    return references.join('; ');
  };
  return (
    <div className={styles.referenceBox}>
      <Text fz={13}>Referencia(s): {referenceString()}</Text>
    </div>
  );
}

export default References;
